/**
 * TOOLS PAGE - FLO SIGNATURE DESIGN SYSTEM v2
 * Clean. Controlled. Consistent. Dark tool mode.
 */

import React, { useState, useCallback } from 'react';
import { PlusIcon } from '@heroicons/react/24/outline';
import { Screen, Section, Button } from '../design/primitives';
import ToolList from '../components/ToolList';
import ToolForm from '../components/forms/ToolForm';

const ToolsPage: React.FC = () => {
  const [isToolFormOpen, setIsToolFormOpen] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  const handleToolCreated = useCallback(() => {
    setRefreshKey(prevKey => prevKey + 1);
  }, []);

  return (
    <Screen>
      <Section
        title="Tools"
        action={
          <Button
            variant="primary"
            onClick={() => setIsToolFormOpen(true)}
            icon={<PlusIcon style={{ width: '16px', height: '16px' }} />}
          >
            New Tool
          </Button>
        }
      >
        <ToolList key={refreshKey} />
      </Section>

      <ToolForm
        isOpen={isToolFormOpen}
        onClose={() => setIsToolFormOpen(false)}
        onToolCreated={handleToolCreated}
      />
    </Screen>
  );
};

export default ToolsPage;
